import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GitCompare, X } from 'lucide-react';
import { useCompare } from '../hooks/useCompare';
import { useTranslation } from '../i18n';

const CompareBar = ({ lang = 'en' }) => {
  const { t } = useTranslation(lang);
  const { list, count, max, remove, clear } = useCompare();
  const location = useLocation();

  // Hide on admin, auth, and compare pages themselves
  const path = location.pathname || '';
  const hideOn = ['/admin', '/login', '/compare', '/forgot-password', '/reset-password'];
  if (hideOn.some((p) => path.startsWith(p))) return null;
  if (count === 0) return null;

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 bottom-6 z-40 max-w-[95vw]"
      data-testid="compare-bar"
    >
      <div
        className="flex items-center gap-3 px-4 py-3 rounded-full shadow-2xl border backdrop-blur"
        style={{
          background: 'rgba(17, 24, 39, 0.92)',
          borderColor: 'rgba(255,255,255,0.08)',
          color: '#fff',
        }}
      >
        <GitCompare className="w-5 h-5 shrink-0 text-amber-300" />
        <div className="flex items-center gap-2 overflow-x-auto max-w-[45vw]">
          {list.map((v) => (
            <div
              key={v.id}
              className="flex items-center gap-1 px-2 py-1 rounded-full text-xs whitespace-nowrap"
              style={{ background: 'rgba(255,255,255,0.08)' }}
              data-testid={`compare-chip-${v.id}`}
            >
              <span className="truncate max-w-[9rem]">
                {v.year} {v.brand} {v.model}
              </span>
              <button
                onClick={() => remove(v.id)}
                className="opacity-70 hover:opacity-100"
                aria-label="Remove"
                data-testid={`compare-chip-remove-${v.id}`}
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
        <span
          className="hidden sm:inline text-xs opacity-70"
          data-testid="compare-bar-count"
        >
          {count}/{max}
        </span>
        <Link
          to="/compare"
          className="px-4 py-1.5 rounded-full text-sm font-semibold bg-amber-400 text-gray-900 hover:bg-amber-300 transition-colors"
          data-testid="compare-bar-open"
        >
          {t('compareBar.compareNow') || t('nav.compare') || 'Compare'}
        </Link>
        <button
          onClick={clear}
          className="text-xs opacity-70 hover:opacity-100 hidden sm:inline"
          data-testid="compare-bar-clear"
        >
          {t('common.clearAll') || 'Clear'}
        </button>
      </div>
    </div>
  );
};

export default CompareBar;
